export default `<dialog role="dialog" aria-modal="true" aria-labelledby="dialog-title">
    <div class="dialog-content">
        <button type="button" class="close" aria-label="Close">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 14 14"
                fill="none"
            >
                <path
                    d="M7.72313 7.24409L7.72313 7.24409C7.68903 7.16245 7.6727 7.07432 7.67538 6.98568M7.72313 7.24409L5.82464 7.00075L6.32352 6.98625C6.32352 6.98606 6.32351 6.98587 6.32351 6.98568C6.31877 6.82759 6.25572 6.67698 6.14662 6.5627L6.14671 6.56261L6.13851 6.55441L1.25439 1.67076C1.2022 1.61565 1.17336 1.54247 1.17397 1.46652C1.17459 1.38938 1.2055 1.3156 1.25984 1.26122C1.31398 1.20702 1.38754 1.17605 1.46495 1.17536C1.5411 1.17467 1.6142 1.20343 1.66916 1.25531L6.55309 6.13876L6.55308 6.13877L6.55538 6.14104C6.67353 6.25766 6.83303 6.32331 6.99946 6.32331C7.16602 6.32331 7.32545 6.25757 7.4435 6.14104L7.4458 6.13876L12.3335 1.25154C12.3335 1.25152 12.3335 1.2515 12.3336 1.25147C12.3608 1.22425 12.3932 1.20265 12.4288 1.1879C12.464 1.17332 12.5022 1.16571 12.5412 1.16571C12.5799 1.16572 12.6181 1.17334 12.6536 1.18807C12.6895 1.20297 12.7218 1.22459 12.7489 1.25164C12.7759 1.27869 12.7976 1.31118 12.8125 1.34712C12.8273 1.38287 12.8349 1.421 12.8349 1.45944C12.8349 1.49796 12.8273 1.5361 12.8125 1.57178L13.2735 1.76289L12.8125 1.57179C12.7977 1.60738 12.7761 1.63976 12.7488 1.66705L12.7487 1.6671L7.86042 6.55439L7.86033 6.5543L7.8523 6.56271C7.74342 6.67676 7.68012 6.82727 7.67538 6.98568M7.72313 7.24409C7.75611 7.32305 7.80454 7.39313 7.86434 7.45102L12.7445 12.3308C12.7967 12.3859 12.8256 12.459 12.8249 12.535C12.8243 12.6119 12.7935 12.6855 12.739 12.74C12.6846 12.7945 12.6109 12.8254 12.534 12.8261C12.4578 12.8268 12.3847 12.7981 12.3297 12.7462L7.4458 7.86273L7.4458 7.86273L7.4435 7.86046C7.32545 7.74393 7.16602 7.67819 6.99946 7.67819C6.83303 7.67819 6.67353 7.74383 6.55538 7.86046L6.55309 7.86273L1.66678 12.7486C1.66659 12.7488 1.66639 12.749 1.66619 12.7492C1.6297 12.7851 1.5845 12.811 1.53501 12.8242C1.48522 12.8375 1.43283 12.8375 1.38307 12.8243C1.33367 12.8112 1.28811 12.7852 1.2512 12.7487C1.21514 12.713 1.18898 12.6688 1.17505 12.6204C1.1622 12.5701 1.16245 12.5173 1.17577 12.4672C1.18918 12.4167 1.21545 12.3705 1.25221 12.3329C1.2525 12.3326 1.25279 12.3323 1.25309 12.332L6.13458 7.45102C6.19436 7.39314 6.24281 7.32306 6.27578 7.2441L7.72313 7.24409ZM7.67538 6.98568L8.17424 7.00075M7.67538 6.98568C7.67537 6.98587 7.67537 6.98606 7.67536 6.98625L8.17424 7.00075M8.17424 7.00075C8.17371 7.01821 8.17694 7.03563 8.18367 7.05175C8.1904 7.06787 8.20051 7.08226 8.21329 7.09416L8.17424 7.00075Z"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="0.998177"
                />
            </svg>
        </button>
        <span class="icon" part="icon">
            <slot name="icon"></slot>
        </span>
        <h2 id="dialog-title">Placeholder</h2>
        <slot name="content"></slot>
        <div class="button-group">
            <button class="primary">Close</button>
        </div>
    </div>
</dialog>

<style>
    svea-dialog {
        font-family: 'Asap', Arial, sans-serif;
        font-size: 1rem;
        position: relative;
    }

    dialog {
        font-family: 'Asap', Arial, sans-serif;
        border-radius: 0.75rem;
        box-shadow: 0 1.5rem 1.5rem #0000004d;
        border: none;
        padding: 5rem;
        max-height: 50%;
        margin-bottom: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    dialog::backdrop {
        background-color: rgba(0, 0, 0, 1);
        opacity: 0.75;
    }

    dialog div {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        row-gap: 1.25rem;
    }

    @media screen and (min-width: 576px) {
        dialog {
            width: fit-content;
            border-radius: 0.75rem;
            margin: auto;
            max-height: auto;
        }

        dialog div {
            max-width: 24rem;
        }
    }

    dialog button.close {
        padding: 1rem;
        align-self: end;
        color: var(--svea-interactive-primary, #00699a);
        cursor: pointer;
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    dialog button.close svg {
        width: 1rem;
        height: 1rem;
    }

    dialog h2 {
        color: var(--svea-text-headline, #00325c);
        font-weight: 600;
        font-style: italic;
        font-size: 2rem;
        line-height: 2.5rem;
        margin: 0;
    }

    dialog p {
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1rem;
        margin: 0;
    }

    dialog .icon {
        background-color: #dbf2c6;
        color: #406d0d;
        border-radius: 50%;
        width: 5.5rem;
        height: 5.5rem;
        align-self: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    dialog .icon svg {
        width: 2.5rem;
        height: 2.5rem;
    }

    dialog button {
        background: transparent;
        border: 0;
        cursor: pointer;
    }

    dialog .button-group {
        margin-top: 1rem;
    }

    dialog .button-group button {
        font-size: 1rem;
        line-height: 1.5rem;
        padding: 0.75rem 2.5rem;
        border-radius: 3.125rem;
    }

    dialog button.primary {
        background-color: var(--svea-interactive-primary, #00699a);
        color: #fff;
    }

    dialog button.primary:focus-visible {
        outline: 0.15rem solid var(--svea-outline-focus, #1b709e);
        outline-offset: 0.25rem;
        box-shadow: none !important;
    }

    dialog button.primary:focus {
        outline: 0.15rem solid var(--svea-outline-focus, #1b709e);
        outline-offset: 0.25rem;
        box-shadow: none;
    }
</style>
`